// INICIO JS PARA SLIDE PAGINA DO PRODUTO

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') return;
    
    var prodSlideImgSwiper = new Swiper('.prod-slide-img-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: '.prod-slide-img-button-next',
        prevEl: '.prod-slide-img-button-prev',
      },
    });
  });

// FINAL JS PARA SLIDE PAGINA DO PRODUTO


// INICIO JS PARA BOTÃO DE VARIAÇÃO

  document.addEventListener('DOMContentLoaded', function() {
    var customSecondSelect = document.querySelector(
      '.product-form__input--custom-second-select select'
    );
    if (!customSecondSelect) return; // não está no modo custom

    // Fieldset escondido da 2ª variação (option_index0 == 1)
    var secondFieldset = document.querySelector(
      'fieldset.product-form__input--custom-second-hidden'
    );
    if (!secondFieldset) return;

    var radios = secondFieldset.querySelectorAll('input[type="radio"]');

    // Sincronizar estado inicial: se algum radio está checked, reflete no select
    var checkedRadio = secondFieldset.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      customSecondSelect.value = checkedRadio.value;
    }

    // Quando o select mudar, marcamos o radio correspondente e disparamos change
    customSecondSelect.addEventListener('change', function() {
      var value = this.value;

      radios.forEach(function(radio) {
        if (radio.value === value) {
          radio.checked = true;
          // Dispara 'change' para o variant-radios tratar e atualizar a variante
          var event = new Event('change', { bubbles: true });
          radio.dispatchEvent(event);
        }
      });
    });
  });

// FINAL JS PARA BOTÃO DE VARIAÇÃO


// INICIO JS PARA DOTS PAGINA DO PRODUTO

  document.addEventListener('DOMContentLoaded', function() {
    var $mainCarousel = $('#main-media-container.single-product.owl-carousel');
    var $dots = $('.product__media-dots .product__media-dot');
    
    if (!$mainCarousel.length || !$dots.length) return;
    
    // Quando clicar no dot, vai para o slide correspondente
    $dots.on('click', function() {
      var index = parseInt($(this).attr('data-dot-index'), 10) || 0;
      $mainCarousel.trigger('to.owl.carousel', [index, 300, true]);
    });
    
    // Mantém o dot "ativo" sincronizado com o slide atual
    $mainCarousel.on('changed.owl.carousel', function(event) {
      if (!event.item) return;
      var currentIndex = event.item.index;
      
      $dots.removeClass('is-active');
      $dots.eq(currentIndex).addClass('is-active');
    });
    
    // Opcional: marca o primeiro como ativo ao carregar
    $dots.first().addClass('is-active');
  });

// FINAL JS PARA DOTS PAGINA DO PRODUTO


// INICIO JS PARA MOVER CONTEUDOS DO PRODUTO

  document.addEventListener("DOMContentLoaded", () => {
    if (window.innerWidth < 767) {
      const blocotolstoy = document.querySelector('.shopify-block.shopify-app-block:has(tolstoy-stories)');
      const destino = document.querySelector('.product-section.topo-mobile .product__info-container');
      const tolstoy = document.querySelector('.shopify-block.shopify-app-block tolstoy-stories');

      if (blocotolstoy && destino && tolstoy) {
        setTimeout(() => {
          if (tolstoy.innerHTML.trim()) {
            destino.appendChild(blocotolstoy);
          } else {
            tolstoy.style.display = 'none';
          }
        }, 600);
      }
    }

    const richtext = document.querySelector('.richtext_content:has(.read-more-link)');
    const jdgm = document.querySelector('.shopify-block.shopify-app-block:has(.jdgm-widget)');
    const destinoBackground = document.querySelector('.product__info-container-background');

    if (richtext && destinoBackground) {
      destinoBackground.appendChild(richtext);
    }

    if (jdgm && destinoBackground) {
      destinoBackground.appendChild(jdgm);
    }

  });

// FINAL JS PARA MOVER CONTEUDOS DO PRODUTO


// INICIO JS PARA LABEL DE VARIAÇÃO GENERICA

  document.addEventListener('DOMContentLoaded', function() {
    function setupVariantLegendUpdates() {
      document.querySelectorAll('.product-form__input').forEach(function(fieldset) {
        if (!fieldset.querySelector('.varinat-image')) return;

        var legend = fieldset.querySelector('legend.form__label');
        if (!legend) return;

        var radio = fieldset.querySelector('input[type="radio"]');
        if (!radio) return;
        var optionName = radio.name;

        // Adiciona o span de valor selecionado na legend se ainda não existe
        if (!legend.querySelector('.selected-variant-value')) {
          var checked = fieldset.querySelector('input[type="radio"]:checked');
          var span = document.createElement('span');
          span.className = 'selected-variant-value';
          span.setAttribute('data-option-name', optionName);
          span.textContent = ': ' + (checked ? checked.value : '');
          legend.appendChild(span);
        }

        // Atualiza o span ao selecionar uma variação
        fieldset.querySelectorAll('input[type="radio"]').forEach(function(r) {
          r.addEventListener('change', function() {
            if (this.checked) {
              var span = legend.querySelector('.selected-variant-value');
              if (span) span.textContent = ': ' + this.value;
            }
          });
        });
      });
    }

    setupVariantLegendUpdates();

    // Rebinda ao clicar em qualquer swatch (para cobrir casos com re-render)
    document.querySelectorAll('.varinat-image, .variant-image').forEach(function(el) {
      el.addEventListener('click', function() {
        setTimeout(setupVariantLegendUpdates, 150);
      });
    });
  });

// FINAL JS PARA LABEL DE VARIAÇÃO GENERICA



// INICIO JS PARA ALTERAR NOME DAS OPÇÕES SELECT ORDENAÇÃO

(function () {
  const labels = {
    "best-selling": "Mais Vendidos",
    "price-ascending": "Menor Preço",
    "price-descending": "Maior Preço",
    "created-descending": "Lançamentos",
    "created-ascending": "Mais Antigos",
    "title-ascending": "A-Z",
    "title-descending": "Z-A",
    "sale-descending": "Maior Desconto"
  };

  const buttonLabels = {
    "Mais Vendidos": "Mais Vendidos",
    "Preço, do menor para o maior": "Menor Preço",
    "Preço, do mais alto ao mais baixo": "Maior Preço",
    "Data, do novo ao antigo": "Lançamentos",
    "Data, do antigo ao novo": "Mais Antigos",
    "Organizar de A-Z": "A-Z",
    "Organizar de Z-A": "Z-A",
    "% de desconto": "Maior Desconto"
  };

  function renameSort() {
    document.querySelectorAll("#globo-dropdown-sort_options li[data-sort]").forEach(function (item) {
      const newLabel = labels[item.dataset.sort];

      if (newLabel) {
        item.textContent = newLabel;
        item.setAttribute("aria-label", newLabel);
      }
    });

    const buttonText = document.querySelector(".sort-by-toggle span");

    if (buttonText) {
      const currentText = buttonText.textContent.trim();

      if (buttonLabels[currentText]) {
        buttonText.textContent = buttonLabels[currentText];
      }
    }

    showSortAfterRename();
  }

  function showSortAfterRename() {
    const filterSelection = document.querySelector(".gf-actions .gf-filter-selection");

    if (filterSelection) {
      filterSelection.classList.add("sort-labels-ready");
    }
  }

  [300, 800, 1500, 2500, 4000].forEach(function (delay) {
    setTimeout(renameSort, delay);
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest(".sort-by")) {
      setTimeout(renameSort, 100);
      setTimeout(renameSort, 500);
    }
  });
})();

// FINAL JS PARA ALTERAR NOME DAS OPÇÕES SELECT ORDENAÇÃO


// INICIO JS PARA FILTRAR VARIAÇÕES SECUNDÁRIAS POR SELEÇÃO

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var jsonEl = document.querySelector(
      'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
    );
    if (!jsonEl) return;

    var allVariants;
    try { allVariants = JSON.parse(jsonEl.textContent); } catch (_) { return; }
    if (!allVariants || !allVariants.length) return;

    var hasOption2 = allVariants.some(function (v) { return v.option2; });
    if (!hasOption2) return;

    // ── Snapshot dos <option> de cada <select> secundário no carregamento ──
    // Guardamos referências aos elementos (não cópias), para reinserir sem
    // alterar estilos, atributos ou event listeners existentes.
    function snapshotSelect(sel) {
      if (!sel) return null;
      return { el: sel, opts: Array.from(sel.options) };
    }

    var customSelect     = document.querySelector('.product-form__input--custom-second-select select');
    var customSnap       = snapshotSelect(customSelect);

    var variantSelectsEl = document.querySelector('variant-selects');
    var dropdownSel2     = variantSelectsEl && variantSelectsEl.querySelectorAll('select')[1] || null;
    var dropdownSnap     = snapshotSelect(dropdownSel2);

    // ── Reconstrói um <select> com apenas os valores disponíveis ──────────
    function rebuildSelect(snap, availableValues) {
      if (!snap) return;
      var sel      = snap.el;
      var prevVal  = sel.value;

      // Remove todas as options atuais (ficam em memória via snap.opts)
      while (sel.options.length > 0) sel.remove(0);

      // Reinsere apenas as disponíveis — mesmos elementos, sem alterar CSS
      snap.opts.forEach(function (opt) {
        if (availableValues.indexOf(opt.value) !== -1) sel.add(opt);
      });

      // Mantém o valor anterior se ainda disponível; caso contrário, primeiro disponível
      if (availableValues.indexOf(prevVal) !== -1) {
        sel.value = prevVal;
      } else if (sel.options.length > 0) {
        sel.value = sel.options[0].value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // ── Quais option2 têm estoque para um dado option1 ────────────────────
    function getAvailableOption2(option1Value) {
      var result = [];
      allVariants.forEach(function (v) {
        if (v.option1 === option1Value && v.available && result.indexOf(v.option2) === -1) {
          result.push(v.option2);
        }
      });
      return result;
    }

    // ── Filtro principal ──────────────────────────────────────────────────
    function filterSecondary(option1Value) {
      var available2 = getAvailableOption2(option1Value);

      // Custom picker: reconstrói o <select> visível (funciona em Safari)
      rebuildSelect(customSnap, available2);

      // Button picker: mostra/oculta containers de radio (div, não option)
      if (!customSelect) {
        var variantRadios = document.querySelector('variant-radios');
        if (variantRadios) {
          var option2Fieldset =
            variantRadios.querySelector('fieldset[data-option-position="1"]') ||
            (variantRadios.querySelectorAll('fieldset')[1] || null);

          if (option2Fieldset) {
            var containers = option2Fieldset.querySelectorAll('.varinat-image, .variant-image');
            containers.forEach(function (container) {
              var input = container.querySelector('input[type="radio"]');
              if (!input) return;
              container.style.display = available2.indexOf(input.value) !== -1 ? '' : 'none';
            });
            var checked2 = option2Fieldset.querySelector('input[type="radio"]:checked');
            if (checked2 && available2.indexOf(checked2.value) === -1) {
              for (var i = 0; i < containers.length; i++) {
                if (containers[i].style.display !== 'none') {
                  var firstInput = containers[i].querySelector('input[type="radio"]');
                  if (firstInput) {
                    firstInput.checked = true;
                    firstInput.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                  break;
                }
              }
            }
          }
        }
      }

      // Dropdown picker: reconstrói o segundo <select>
      rebuildSelect(dropdownSnap, available2);
    }

    // Escuta mudança na opção 1 dentro de variant-radios
    var variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      var option1Fieldset =
        variantRadios.querySelector('fieldset[data-option-position="0"]') ||
        variantRadios.querySelector('fieldset');

      if (option1Fieldset) {
        option1Fieldset.addEventListener('change', function (e) {
          if (e.target.type === 'radio') filterSecondary(e.target.value);
        });
        var checked1 = option1Fieldset.querySelector('input[type="radio"]:checked');
        if (checked1) filterSecondary(checked1.value);
      }
    }

    // Escuta mudança na opção 1 dentro de variant-selects (dropdown picker)
    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      var firstSelect = variantSelects.querySelector('select');
      if (firstSelect) {
        firstSelect.addEventListener('change', function () { filterSecondary(this.value); });
        filterSecondary(firstSelect.value);
      }
    }
  });
})();

// FINAL JS PARA FILTRAR VARIAÇÕES SECUNDÁRIAS POR SELEÇÃO


// INICIO JS PARA MINIATURAS ABAIXO DO PRODUTO

(function () {
  var ITEM_SIZE = 88; // 80px + 8px gap

  function syncThumbs(index) {
    var $thumbs = jQuery('.product__media-list-2 .product_thumbnail_item');
    $thumbs.removeClass('active').eq(index).addClass('active');

    var container = jQuery('.product__media-list-2')[0];
    if (!container) return;
    var targetScroll = Math.max(0, index * ITEM_SIZE - container.clientWidth / 2 + ITEM_SIZE / 2);
    container.scrollTo({ left: targetScroll, behavior: 'smooth' });
  }

  function enableDrag(container) {
    var isDown = false;
    var startX, scrollLeft;

    container.addEventListener('mousedown', function (e) {
      isDown = true;
      container.classList.add('is-dragging');
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener('mouseleave', function () {
      isDown = false;
      container.classList.remove('is-dragging');
    });

    container.addEventListener('mouseup', function () {
      isDown = false;
      container.classList.remove('is-dragging');
    });

    container.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - container.offsetLeft;
      var walk = (x - startX) * 1.5;
      container.scrollLeft = scrollLeft - walk;
    });
  }

  function init() {
    if (typeof jQuery === 'undefined') { setTimeout(init, 100); return; }

    var $mainCarousel = jQuery('#main-media-container.single-product');
    if (!$mainCarousel.length || !$mainCarousel.data('owl.carousel')) { setTimeout(init, 100); return; }

    var $thumbStrip = jQuery('.product__media-list-2');
    if (!$thumbStrip.length) return;

    // Drag-to-scroll com mouse (touch já funciona nativamente)
    enableDrag($thumbStrip[0]);

    // Ao trocar slide principal, centraliza miniatura ativa
    $mainCarousel.on('changed.owl.carousel', function (event) {
      if (!event.item) return;
      syncThumbs(event.item.index);
    });

    // Clique em miniatura navega o carousel principal
    $thumbStrip.on('click', '.product_thumbnail_item', function () {
      if ($thumbStrip.hasClass('is-dragging')) return;
      var index = jQuery(this).index();
      $mainCarousel.trigger('to.owl.carousel', [index, 300, true]);
      syncThumbs(index);
    });

    // Ao trocar variação, sincronizar miniatura correspondente à mídia da variante
    document.addEventListener('change', function (e) {
      var picker = e.target.closest('variant-radios, variant-selects');
      if (!picker) return;

      setTimeout(function () {
        var variantInput = document.querySelector('input[name="id"]');
        if (!variantInput) return;

        var jsonScript = picker.querySelector('script[type="application/json"]');
        if (!jsonScript) return;

        var variants;
        try { variants = JSON.parse(jsonScript.textContent); } catch (_) { return; }

        var variant = variants.find(function (v) {
          return String(v.id) === String(variantInput.value);
        });
        if (!variant || !variant.featured_media) return;

        var mediaId = String(variant.featured_media.id);
        var $allThumbs = jQuery('.product__media-list-2 .product_thumbnail_item');
        var idx = -1;
        $allThumbs.each(function (i) {
          var mid = jQuery(this).attr('data-media-id') || '';
          if (mid.slice(-mediaId.length - 1) === '-' + mediaId) { idx = i; return false; }
        });

        if (idx >= 0) syncThumbs(idx);
      }, 150);
    });

    // Estado inicial
    jQuery(window).on('load', function () {
      setTimeout(function () {
        var $current = jQuery('#main-media-container [data-current-variant-media="true"]').first();
        if ($current.length) {
          var idx = parseInt($current.attr('data-media-index'), 10);
          if (!isNaN(idx)) {
            $mainCarousel.trigger('to.owl.carousel', [idx, 0, true]);
            syncThumbs(idx);
            return;
          }
        }
        syncThumbs(0);
      }, 200);
    });

    syncThumbs(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 300); });
  } else {
    setTimeout(init, 300);
  }
})();

// FINAL JS PARA MINIATURAS ABAIXO DO PRODUTO

